import { useSession } from "../Components/Session";
import API from "../Services/API";
import Model from "./Model";

const useBusinessCoordinates = () => {
    return Model({
        stateKey: ['business', 'coordinates'],
        fetchData: () => API.get('business/coordinates').catch(() => null),
        returnDataKey: 'coordinates',
        defaultLoadingError: 'Sorry, there was an error loading business location.',
    });
}

const useBusiness = (alwaysRefresh = false) => {
    const {refresh} = useSession();

    return Model({
        alwaysRefresh,
        stateKey: ['business'],
        fetchData: () => API.get('business'),
        returnDataKey: 'business',
        registerAdditionalMethods: (opts) => {
            return {
                saveDetails: (data) => {
                    if (!data.postcode && data.address) {
                        data.postcode = data.address.postcode
                    }
                    return opts.wrapUpdateCall(
                        () => API.post('/business/details', data).then(refresh),
                        'Business details saved',
                        true,
                    );
                },
                saveSocials: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/business/socials', data).then(refresh),
                        'Social media links saved',
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading business details.',
    });
}

const useGrants = () => {
    const data = Model({
        stateKey: ['business', 'grants'],
        fetchData: () => API.get('business/grants').catch(() => null),
        returnDataKey: 'grants',
        registerAdditionalMethods: (opts) => {
            return {
                addUser: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/business/grants', data),
                        'User added',
                        true,
                    );
                },
                removeUser: (grantId) => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/business/grants/${grantId}`),
                        'User removed',
                        true,
                    );
                },
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading business users.',
    });

    return {
        ...data,
        activeGrants: data?.grants?.filter(g => g.status === 'Active'),
        keyedByUserId: data?.grants?.reduce((acc, g) => {
            acc[g.userId] = g.firstName ? `${g.firstName} ${g.lastName}` : g.email;
            return acc;
        }, {}),
    }
}

export {
    useBusiness,
    useBusinessCoordinates,
    useGrants,
}
